<template>
  <div class="container mt-5">
    <h2>Folder Tree View</h2>

    <div class="mb-3">
      <input v-model="hash" class="form-control" placeholder="Enter folder hash" />
      <button @click="loadFolderTree" class="btn btn-primary mt-2">Load Tree</button>
      <div v-if="error" class="alert alert-danger mt-2">{{ error }}</div>
    </div>

    <div v-if="isTreeLoaded && !error">
      <!-- Отображение содержимого главной папки через компонент TreeNode -->
      <div v-if="folderTreeData && folderTreeData.children && folderTreeData.children.length > 0" class="mt-4">
        <ul class="list-group">
          <tree-node
            v-for="node in folderTreeData.children"
            :key="node.name"
            :node="node"
            @action="handleAction"
          ></tree-node>
        </ul>
      </div>

      <!-- Сообщение, если папка пуста -->
      <div v-else class="mt-4">
        <p class="text-muted">The folder is empty.</p>
      </div>
    </div>
  </div>
</template>

<script>
import { apiUrl, loadConfig } from '../axiosRequest.js';
import { mapActions, mapGetters } from 'vuex';
import TreeNode from './TreeNode.vue'; // Подключаем компонент TreeNode

let axiosInstance = null; // Глобальная переменная для хранения загруженного инстанса axios

async function getAxiosInstance() {
  if (!axiosInstance) {
    axiosInstance = await loadConfig(); // Загружаем только один раз
  }
  return axiosInstance;
}

export default {
  components: {
    TreeNode,
  },
  data() {
    return {
      hash: '',
      file: null,
      error: null,
      isTreeLoaded: false, // Для отслеживания загрузки дерева
      isOneTimeFile: false, // Для отслеживания одноразового файла
      expirationPeriod: 1, // Период хранения
      uploadError: null, // Ошибка загрузки
      uploadSuccess: null, // Успех загрузки
    };
  },
  computed: {
    ...mapGetters(['getFolderTreeData']),
    folderTreeData() {
      return this.getFolderTreeData;
    }
  },
  methods: {
    ...mapActions(['saveFolderTreeData']),
    onFileChange(event) {
      this.file = event.target.files[0];
    },
    async loadFolderTree() {
        if (!this.hash) {
            this.error = 'Please enter a folder hash';
            return;
        }

        try {
            const axios = await getAxiosInstance();
            const response = await axios.get(`/files/FolderTree/${this.hash}`);
            this.saveFolderTreeData(response.data); // Сохраняем данные в Vuex
            this.error = null;
            this.isTreeLoaded = true;
            console.log("Folder Tree Data:", response.data); // Проверка данных
        } catch (error) {
            console.error('Error loading folder tree:', error);
            this.error = 'Invalid folder hash or folder does not exist.';
            this.isTreeLoaded = true;
        }
    },
    async uploadFileToFolder() {
      if (!this.file) {
        this.uploadError = 'Please select a file to upload';
        return;
      }

      const formData = new FormData();
      formData.append('file', this.file);

      const expirationType = this.isOneTimeFile ? 0 : this.expirationPeriod;

      try {
        this.uploadError = null;
        this.uploadSuccess = null;

        const axios = await getAxiosInstance();
        const response = await axios.post(`/files/Upload/${this.hash}`, formData, {
          params: {
            expirationType: expirationType,
          },
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        });
        console.log(response);
        this.uploadSuccess = 'File uploaded successfully';
        this.loadFolderTree(); // Обновляем содержимое папки после загрузки файла
      } catch (error) {
        console.error('Error uploading file:', error);
        this.uploadError = 'Error uploading file';
      }
    },
    async handleAction(action, file) {
      console.log("Received file in handleAction:", file);
      const axios = await getAxiosInstance();
      switch (action) {
          case 'download':
              try {
                const response = await axios({
                    url: `${apiUrl}api/Files/Download/${file.downloadlink}`, // Полный downloadlink
                    method: 'GET',
                    responseType: 'blob',
                });

                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', file.name || 'downloaded_file');
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            } catch (downloadError) {
                console.error('Error downloading file:', downloadError);
                alert('Failed to download the file.');
            }
            break;
        case 'delete':
            try {
                await axios.delete(`${apiUrl}api/Files/Delete/${file.deletelink}`);
                this.loadFolderTree(); // Обновляем дерево после удаления файла
            } catch (error) {
                console.error('Error deleting file:', error);
                alert('Failed to delete the file.');
            }
            break;
        case 'copy-link':
            try {
              console.log(file);
                await navigator.clipboard.writeText(`${apiUrl}api/Files/Download/${file.downloadlink}`);
            } catch (err) {
                console.error('Failed to copy: ', err);
            }
            break;
    }
},

    copyDownloadLink(downloadUrl) {
      navigator.clipboard.writeText(downloadUrl).then(() => {
        //alert('Download link copied to clipboard');
      }).catch((err) => {
        console.error('Error copying link: ', err);
      });
    }
  },
};
</script>

<style scoped>
.list-group-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.me-2 {
  margin-right: 0.5rem;
}
</style>
